import React, { createContext, useContext, useEffect, useState } from "react";
import { showAlert } from "../../../../config/utils";

const KEY = "image_gallery_clipboard";
const defaultClip = { clientId: null, sourceEntityId: null, entityType: null, itemIds: [] };

function read() {
  try { return JSON.parse(localStorage.getItem(KEY)) || defaultClip; } catch { return defaultClip; }
}
function write(val) {
  try { localStorage.setItem(KEY, JSON.stringify(val)); } catch {}
}

const Ctx = createContext(null);

export const ClipboardProvider = ({ children }) => {
  const [clip, setClip] = useState(read);

  useEffect(() => { write(clip); }, [clip]);

  useEffect(() => {
    const onStorage = e => {
      if (e.key === KEY && e.storageArea === localStorage) {
        try { setClip(e.newValue ? JSON.parse(e.newValue) : defaultClip); } catch {}
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const copy = ({ clientId, sourceEntityId, entityType, itemIds }) =>{
    setClip({ clientId, sourceEntityId, entityType, itemIds });
    showAlert('Image(s) Copied')
  }

  const clear = () => setClip(defaultClip);

  return <Ctx.Provider value={{ clip, copy, clear }}>{children}</Ctx.Provider>;
};


export const useClipboard = () => {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useClipboard must be used inside ClipboardProvider");
  return ctx;
};
